import Monster from './monster.js';

export default Monster;